export default __webpack_public_path__ + "static/media/download.88b7ae94.svg";